import styled, { keyframes } from 'styled-components';

// Blinking cursor animation
export const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

// Reusable BlinkingCursor component for terminal sections
export const BlinkingCursor = styled.span`
  display: inline-block;
  animation: ${blink} 1.2s infinite;
  font-weight: bold;
  margin-left: 4px;
  color: ${({ theme, color }) => color || theme.primary};
  font-family: 'Courier New', monospace;
`;
